// extracted by css-extract-rspack-plugin
var _1 = "description-CiMioc";
var _2 = "name-bl1cLY";
var _3 = "name-container-JMkten";
var _4 = "name-container-JMkten";
export { _1 as "description", _2 as "name", _3 as "name-container", _4 as "nameContainer" }
